import { ChevronUp } from 'lucide-react';
import styled from 'styled-components';

// TopBar Container
export const StyledTopBarContainer = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-4);
  background-color: var(--color-white);
  box-shadow: var(--shadow-sm);
  border-bottom: 1px solid var(--color-gray-200);
`;

// Menu Button
export const StyledMenuButton = styled.button`
  color: var(--color-gray-500);
  padding: var(--spacing-1);
  border-radius: var(--radius-md);
  transition: var(--transition-fast);
  border: none;
  background: transparent;
  cursor: pointer;

  &:hover {
    color: var(--color-gray-700);
    background-color: var(--color-gray-100);
  }

  &:focus {
    outline: none;
  }
`;

// User Info Container
export const StyledUserInfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
  position: relative;
`;

// User Details
export const StyledUserDetails = styled.div`
  text-align: right;
`;

// User Info Row
export const StyledUserInfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
`;

// User Name
export const StyledUserName = styled.p`
  font-size: var(--font-size-14);
  font-weight: var(--font-weight-semibold);
  color: var(--color-gray-800);
  margin: 0;
  word-wrap: break-word;
`;

// User Email
export const StyledUserEmail = styled.p`
  font-size: var(--font-size-12);
  color: var(--color-gray-500);
  margin: 0;
  word-wrap: break-word;
`;

//profile menu item
export const StyledProfileItem = styled.button`
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  width: 100%;
  // padding: var(--spacing-1);
  margin-top: var(--spacing-2);
  color: var(--color-gray-700);
  background-color: transparent;
  border: none;
  font-size: var(--font-size-16);
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    color: var(--color-gray-900);
    background-color: var(--color-gray-25);
  }
`;

// Last Login
export const StyledLastLogin = styled.p`
  font-size: var(--font-size-12);
  color: var(--color-gray-400);
  margin: var(--spacing-1) 0 0 0;
`;

// Avatar Container
export const StyledAvatarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--spacing-10);
  height: var(--spacing-10);
  background-color: var(--color-gray-100);
  border-radius: var(--radius-full);
  cursor: pointer;
  font-size: var(--font-size-18);
  font-weight: semibold;
`;
export const StyledChevron = styled(ChevronUp)<{ $isExpanded: boolean }>`
  margin-top: 2px;
  cursor: pointer;
  transform: ${props => (props.$isExpanded ? 'rotate(0)' : 'rotate(180deg)')};
  transition: transform 300ms;
`;
export const StyledPopupContainer = styled.div`
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  width: fit-content;
  min-width: 240px;
  max-width: 320px;
  background-color: var(--color-white);
  border-radius: var(--radius-md);
  border: 1px solid var(--color-gray-200);
  box-shadow: var(--shadow-md);
  z-index: 50;
`;

export const StyledPopupContent = styled.div`
  padding: var(--spacing-3);
`;

// Logout Button
export const StyledLogoutButton = styled.button`
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  width: 100%;
  padding: var(--spacing-3);
  color: var(--color-gray-700);
  background-color: transparent;
  border: none;
  border-top: 1px solid var(--color-gray-200);
  font-size: var(--font-size-14);
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: var(--color-gray-50);
    color: var(--color-gray-900);
  }

  svg {
    color: var(--color-gray-500);
  }

  &:hover svg {
    color: var(--color-gray-700);
  }
`;

// Not Authenticated Container
export const StyledNotAuthContainer = styled.div`
  text-align: right;

  p {
    font-size: var(--font-size-14);
    color: var(--color-gray-500);
    margin: 0;
  }
`;
